'use strict'
require('core-js/modules/es.array.some')
require('core-js/modules/es.array.sort')
require('core-js/modules/es.number.constructor')
require('core-js/modules/es.number.is-nan')
require('core-js/modules/es.object.keys')
exports.__esModule = true
exports.default = isEqual

var _is = require('../is')
var _obj = require('../obj')

/* eslint-disable no-use-before-define */
function isEqual(val1, val2) {
  var type1 = (0, _obj.getFullType)(val1)
  var type2 = (0, _obj.getFullType)(val2)
  if (type1 !== type2) return false
  switch (true) {
    case (0, _is.isArr)(val1):
      return isArrEqual(val1, val2)
    case (0, _is.isObj)(val1):
      return isObjEqual(val1, val2)
    case Number.isNaN(val1):
      return Number.isNaN(val2)
    default:
      return val1 === val2
  }
}

function isArrEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false

  return !arr1.some(function(val, ind) {
    return !isEqual(val, arr2[ind])
  })
}

function isObjEqual(obj1, obj2) {
  var keys1 = Object.keys(obj1)
  var keys2 = Object.keys(obj2)
  if (!isArrEqual(keys1.sort(), keys2.sort())) return false
  return !keys1.some(function(key) {
    return !isEqual(obj1[key], obj2[key])
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/misc/isEqual.js
// module id = 641
// module chunks = 0